// extracted by mini-css-extract-plugin
module.exports = {"stationOfflineHeading":"WindStationOffline_stationOfflineHeading__PbgAB"};